// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passwordChangedContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.tickIcon{
    margin-top: 56px;
    height: 100px;
    width: 100px;
}
.backToLoginContainer{
    margin-top: 22px;
}

@media (max-width: 1640px) {
    .tickIcon{
        margin-top: 50px;
        height: 80px;
        width: 80px;
    }
    .backToLoginContainer{
        margin-top: 18px;
    }
}
@media (max-width: 1440px) {
    .tickIcon{
        margin-top: 40px;
        height: 70px;
        width: 70px;
    }
    .backToLoginContainer{
        margin-top: 14px;
    }
}
@media (max-width: 1280px) {
    .tickIcon{
        margin-top: 30px;
        height: 60px;
        width: 60px;
    }
}
@media (max-width: 1024px) {
    .tickIcon{
        margin-top: 20px;
        height: 50px;
        width: 50px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SignInFlow/PasswordChanged/PasswordChanged.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,WAAW;IACf;AACJ","sourcesContent":[".passwordChangedContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.tickIcon{\n    margin-top: 56px;\n    height: 100px;\n    width: 100px;\n}\n.backToLoginContainer{\n    margin-top: 22px;\n}\n\n@media (max-width: 1640px) {\n    .tickIcon{\n        margin-top: 50px;\n        height: 80px;\n        width: 80px;\n    }\n    .backToLoginContainer{\n        margin-top: 18px;\n    }\n}\n@media (max-width: 1440px) {\n    .tickIcon{\n        margin-top: 40px;\n        height: 70px;\n        width: 70px;\n    }\n    .backToLoginContainer{\n        margin-top: 14px;\n    }\n}\n@media (max-width: 1280px) {\n    .tickIcon{\n        margin-top: 30px;\n        height: 60px;\n        width: 60px;\n    }\n}\n@media (max-width: 1024px) {\n    .tickIcon{\n        margin-top: 20px;\n        height: 50px;\n        width: 50px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
